import { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye } from '@fortawesome/pro-solid-svg-icons/faEye'
import { useTranslation } from 'react-i18next'
import ProfileModal from 'components/reusables/profileModal'
import {
  LmsProfileCourseKind,
  LmsProfileResourceType,
} from 'api/lms-profiles/GetProfilesByResource'
import styles from './styles.module.scss'

interface IProps {
  resourceId: number | string
  resourceType: LmsProfileResourceType
  count: number
  translationKey?: string
  /** Solo cursos: filtra perfiles obligatorios u opcionales. */
  kind?: LmsProfileCourseKind
}

/**
 * Celda "X perfiles" + eyes que abre el modal de perfiles (incl. restringidos).
 */
export const ProfilesCountCell = ({
  resourceId,
  resourceType,
  count,
  translationKey = 'commons.profilesCount',
  kind,
}: IProps) => {
  const { t } = useTranslation()
  const [showDetail, setShowDetail] = useState(false)
  const safeCount = count || 0

  if (safeCount === 0) {
    return <span className={styles.emptyValue}>--</span>
  }

  return (
    <>
      <span
        className={styles.profilesWrapper}
        onClick={() => setShowDetail(true)}
        role="button"
        tabIndex={0}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') setShowDetail(true)
        }}
      >
        {t(translationKey, {
          count: safeCount,
          defaultValue:
            safeCount === 1 ? `${safeCount} perfil` : `${safeCount} perfiles`,
        })}
        <FontAwesomeIcon icon={faEye} />
      </span>
      {showDetail && (
        <ProfileModal
          resourceId={resourceId}
          resourceType={resourceType}
          kind={kind}
          close={() => setShowDetail(false)}
        />
      )}
    </>
  )
}

export default ProfilesCountCell
